import { withDependencies } from '@wix/thunderbolt-ioc'
import type { FunctionLibraryRegistry } from './types'

export const BuilderFunctionLibraryRegistry = withDependencies([], (): FunctionLibraryRegistry => {
	const registry: { [type: string]: any } = {}
	return {
		registerFunctionLibrary: (type: string, module: any) => {
			registry[type] = module
		},
		has(type: string) {
			return Boolean(registry[type])
		},
		getFunction: (type: string, functionName: string) => {
			const module = registry[type]
			if (!module) {
				console.warn(
					`Function library "${type}" is not registered. ` + `Did the function library module load before rendering?`
				)
				return undefined
			}

			const fn = module[functionName]
			if (typeof fn !== 'function') {
				console.warn(
					`Function library "${type}" does not export function "${functionName}". ` +
						`Available exports: [${Object.keys(module).join(', ')}]`
				)
				return undefined
			}

			return fn
		},
	}
})
